/**
 * Function for stringifying the filters from planAction Filterline
 * It also translates the values.
 */
import type {
  FilterGroups,
  FilterValues,
} from 'src/components/app/context/FilterContext';

export function stringifyFilters(
  filterGroups: FilterGroups,
  t: (key: string) => string,
): string {
  return Object.entries(filterGroups)
    .map(([name, values]) => formatLabel(name, values, t))
    .join(' AND ');
}

/**
 * Function for translating the filter if it is one of the following.
 * - True
 * - False
 * - Parent
 * - Child
 *
 * **We need to pass the t function to access the translation.**
 */
export function translateFilters(
  valueOrKey: string | boolean,
  t: (key: string) => string,
): string {
  if (typeof valueOrKey === 'boolean')
    return valueOrKey
      ? t('Statistics.Filters.True')
      : t('Statistics.Filters.False');
  if (valueOrKey === 'parent') {
    return t('Statistics.Filters.nestedFilters.parent');
  } else if (valueOrKey === 'child') {
    return t('Statistics.Filters.nestedFilters.child');
  }
  return valueOrKey;
}

export function formatLabel(
  name: string,
  values: FilterValues,
  t: (key: string) => string,
) {
  const value = values[0];
  if (!value) return '';
  if (name === 'orgUnit') {
    return `${value.label}`;
  }
  const translatedText = translateFilters(value.filterExpr[name], t);
  return `${value.label}: ${translatedText || value.filterExpr[name]}`;
}
